import { deleteRequest, getRequest } from '../../../services/base'
import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { createSearchParams, useParams } from 'react-router-dom'
import CreateUpdateConnector from './form'
import { ConnectorContext } from './context/context'
import ConnectorListRow from './ConnectorRow'
import InputText from '../../common/InputText'
import Button from '../../common/Button'
import Select from 'react-select'
import { downloadFileBlob, toTitleCase } from '../../../utils/common'
import LinkWithStatus from '../../common/LinkWithStatus'
import DuplicatePartNumber from './duplicate'
import { getSessionStorageData } from '../../../utils/SessionStorage'
import ConnectorHotSpotModal from './connector_hot_spot'

const SVG_FILTERS_OPTIONS = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'with_svg',
    label: 'With Connector Layout',
  },
  {
    value: 'without_svg',
    label: 'Without Connector Layout',
  },
]

const LOCATION_FILTERS_OPTIONS = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'yes',
    label: 'With Vehicle Views',
  },
  {
    value: 'no',
    label: 'Without Vehicle Views',
  },
]

const ConnectorList = (props) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)
  const [connectorState, connectorDispatch] = useContext(ConnectorContext)
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  const [selectedCategory, setSelectedCategory] = useState(null)
  const [categoryOptions, setCategoryOptions] = useState([])
  const [selectedSvgFilter, setSelectedSvgFilter] = useState(
    SVG_FILTERS_OPTIONS[0]
  )
  const currentUrl = useRef(`/api/connector/?vehicle=${vehicle}`)
  const [showDuplicatePartNumberModal, setShowDuplicatePartNumberModal] =
    useState(false)
  const [connectorHotSpot, setConnectorHotSpot] = useState([])
  const [selectedLocationFilter, setSelectedLocationFilter] = useState(
    LOCATION_FILTERS_OPTIONS[0]
  )

  useEffect(() => {
    getConnectorList(null)
    getConnectorCategoryList()

    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Connector`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  const getConnectorList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Connector`s Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(currentUrl.current)
    connectorDispatch({ type: 'set_connector_data', data: response.results })
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const getConnectorCategoryList = async () => {
    let response = await getRequest(
      `/api/connector/category/?vehicle=${vehicle}`
    )
    setCategoryOptions(response.data)
  }

  const deleteConnector = async (connector) => {
    if (
      window.confirm(`Are you sure want to delete ${connector.name}`) === true
    ) {
      let res = await deleteRequest(
        `/api/connector/delete/${vehicle}/${connector.name}/`
      )
      getConnectorList('')
    }
  }

  const exportConnector = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Downloading Connectors Data',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/connector/download/?vehicle=${vehicle}&search=${searchValue}&category=${selectedCategory?.value ? selectedCategory?.value : ''}&svg_filter=${selectedSvgFilter?.value ? selectedSvgFilter?.value : ''}&location_filter=${selectedLocationFilter?.value ? selectedLocationFilter?.value : ''}`,
      true,
      true
    )
    if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `${vehicle}_connectors.csv`)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  const onPartNumberSelect = (connector, index) => {
    if (connector?.fpn) {
      connectorDispatch({
        type: 'set_selected_connector',
        data: { ...connector, index: index },
      })
      setShowDuplicatePartNumberModal(true)
    } else {
      alert(`Part Number Not exists for selected connector ${connector?.name}`)
    }
  }

  const downloadSvgFile = async (connector) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Downloading Connectors SVG...',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/connector/download/svg/${connector.name}/?vehicle=${vehicle}`,
      true,
      true
    )
    if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `${connector.name}.zip`)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  const showVehicleView = (location) => {
    setConnectorHotSpot(location)
  }

  return (
    <div className="w-full">
      <CreateUpdateConnector
        showModal={showModal}
        setShowModal={setShowModal}
        getConnectorList={getConnectorList}
      />
      {showDuplicatePartNumberModal && (
        <DuplicatePartNumber
          showDuplicatePartNumberModal={showDuplicatePartNumberModal}
          setShowDuplicatePartNumberModal={setShowDuplicatePartNumberModal}
        />
      )}
      {connectorHotSpot?.length > 0 && (
        <ConnectorHotSpotModal
          connector_views={connectorHotSpot}
          setConnectorHotSpot={setConnectorHotSpot}
        />
      )}

      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          currentUrl.current = `/api/connector/?vehicle=${vehicle}&search=${searchValue}&category=${selectedCategory?.value ? selectedCategory?.value : ''}&svg_filter=${selectedSvgFilter?.value ? selectedSvgFilter?.value : ''}&location_filter=${selectedLocationFilter?.value ? selectedLocationFilter?.value : ''}`
          getConnectorList()
        }}
      >
        <div className={`flex space-x-2 content-center items-center`}>
          <div className="flex items-center w-1/3">
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Name, Description`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
            </div>
          </div>
          <Select
            classNamePrefix="dtcs-filter"
            isMulti={false}
            value={selectedCategory}
            options={categoryOptions.map((val) => ({
              value: val,
              label: toTitleCase(val),
            }))}
            placeholder="Select Category"
            className="w-56 cursor-pointer"
            onChange={(value) => {
              setSelectedCategory(value)
            }}
            isClearable={true}
          />
          <Select
            classNamePrefix="dtcs-filter"
            isMulti={false}
            value={selectedSvgFilter}
            options={SVG_FILTERS_OPTIONS}
            placeholder="Select SVG Filters"
            className="w-56 cursor-pointer"
            onChange={(value) => {
              setSelectedSvgFilter(value)
            }}
            isClearable={true}
          />
          <Select
            classNamePrefix="dtcs-filter"
            isMulti={false}
            value={selectedLocationFilter}
            options={LOCATION_FILTERS_OPTIONS}
            placeholder="Select Location Filters"
            className="w-56 cursor-pointer"
            onChange={(value) => {
              setSelectedLocationFilter(value)
            }}
            isClearable={true}
          />
          <Button
            className={`cursor-pointer btn my-4 justify-end`}
            text={`Search`}
            onClick={() => {}}
          />
          <LinkWithStatus
            href={`/connector/export`}
            className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
            title={`Export`}
            onClickFunc={() => {
              exportConnector()
            }}
          />
        </div>
      </form>

      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 pl-2 items-center">Name</div>
          <div className="flex w-1/12 pl-6 items-center">Category</div>
          <div className="flex w-2/12 pl-6 items-center">Description</div>
          <div className="flex w-1/12 pl-6 items-center">Device</div>
          <div className="flex w-1/12 pl-6 items-center">Alias</div>
          <div className="flex w-1/12 pl-6 items-center">Color</div>
          <div className="flex w-1/12 pl-6 items-center">SVG</div>
          <div className="w-1/12 pl-6">Cavities</div>
          <div className="flex w-1/12 pl-6 items-center">Location</div>
          <div className="w-1/12 pl-6"></div>
        </div>
      </div>
      {connectorState?.data?.map((connector, index) => {
        return (
          <ConnectorListRow
            {...connector}
            key={`connector-${index}`}
            onEdit={() => {
              connectorDispatch({
                type: 'set_selected_connector',
                data: { ...connector, index: index },
              })

              setShowModal(true)
            }}
            onDelete={() => deleteConnector(connector)}
            onPartNumberSelect={() => {
              onPartNumberSelect(connector, index)
            }}
            downloadSvgFile={() => {
              downloadSvgFile(connector)
            }}
            showVehicleView={() => {
              showVehicleView(connector.location)
            }}
          />
        )
      })}
      {connectorState?.data?.length < 1 && (
        <NoRecordsFound caption={"User's Not Found"} loading={false} />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getConnectorList(e)
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getConnectorList(e)
          }}
        />
      </div>
    </div>
  )
}

export default ConnectorList
